import { PuzzleGameEnum } from '@enums/PuzzleGameEnum';
import { BGGame } from '@models/bgGame.model';

/**
 * Static Brain Game catalog used during this module.
 *
 * Notes:
 * - `image` uses local assets (`assets/...`). Replace the placeholder svgs with your final 125x125 images when ready.
 * - `description` is intentionally simple placeholder copy; feel free to refine.
 */
export const BRAIN_GAME_GAMES_STATIC: BGGame[] = [
  {
    id: 'Brain_Defense',
    name: 'Brain Defense',
    gameName: PuzzleGameEnum.Tower,
    route: 'braingame/tower-defense',
    image: 'assets/brain-game/brain-defense.png',
    tagline: 'Guard against enemies of a healthy brain in this animated adventure.',
    description: ['Guard your brain. Pick strategies. Defend your progress.'],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'Lemonade',
    name: 'Lemonade',
    gameName: PuzzleGameEnum.Lemonade,
    route: 'braingame/lemonade',
    image: 'assets/brain-game/lemonade.png',
    tagline: 'Become a lemonade tycoon! Open your own lemonade stand and try to become a top seller.',
    description: [
      'Make smart choices under time pressure.',
      'Adapt to changing conditions.',
      'Optimize your strategy to improve your score.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'Sudoku',
    name: 'Number Grid',
    gameName: PuzzleGameEnum.Sudoku,
    route: 'braingame/sudoku',
    image: 'assets/brain-game/number-grid.png',
    tagline: 'More of a numbers person? This is the game for you! Follow the rules and get all the numbers in the right spot.',
    description: [
      'Follow the rules.',
      'Place numbers carefully.',
      'Spot patterns to solve faster.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'Puzzle_Master',
    name: 'Puzzle Master',
    gameName: PuzzleGameEnum.Sliding,
    route: 'braingame/sliding',
    image: 'assets/brain-game/puzzle-master.png',
    tagline: 'The puzzle of all puzzles. Slide puzzle pieces around without lifting them up to solve the puzzle.',
    description: [
      'Slide pieces into position.',
      'Plan ahead to avoid dead ends.',
      'Finish faster to improve your score.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'Synapse_Scramble',
    name: 'Synapse Scramble',
    gameName: PuzzleGameEnum.Trail,
    route: 'braingame/trail-making',
    image: 'assets/brain-game/synapse-scramble.png',
    tagline: 'Letters? Numbers? This game has it all! Set up neural pathways to fire in order for maximum points.',
    description: [
      'Connect pathways in the right order.',
      'Build accuracy and speed over time.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'The_Fame_Game',
    name: 'The Fame Game',
    gameName: PuzzleGameEnum.GuessWho,
    route: 'braingame/guess-who',
    image: 'assets/brain-game/the-fame-game.png',
    tagline: 'Are you looking to test your memory of popular figures?',
    description: [
      'Test your recognition and recall.',
      'Make choices quickly and accurately.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'Large_Sudoku',
    name: 'Timed Sudoku',
    gameName: PuzzleGameEnum.LargeSudoku,
    route: 'braingame/large-sudoku',
    image: 'assets/brain-game/timed-sudoku.png',
    tagline: 'Solve a 9x9 standard size Sudoku',
    description: [
      'Race the clock.',
      'Stay accurate under pressure.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
  {
    id: 'Bridge',
    name: 'Bridge',
    gameName: PuzzleGameEnum.Bridge,
    route: 'braingame/bridge',
    image: 'assets/brain-game/bridge.png',
    tagline: 'Practice strategy and decision-making in a classic card game challenge.',
    description: [
      'Choose a difficulty to begin.',
      'Learn, adapt, and improve your play.',
    ],
    performance: { recent: 0, high: 0 },
    skips: 0,
  },
] ;


